import { Divider, Stack } from "@mui/material";
import { BalanceVisibilityToggle } from "Components/UserAccount/Shared/UserSettings/BalanceVisibilityToggle";
import { PasswordSection } from "Components/UserAccount/Shared/UserSettings/PasswordSection";
import { QuickPaymentToggle } from "Components/UserAccount/Shared/UserSettings/QuickPaymentToggle";
import { TerminateChatSection } from "Components/UserAccount/Shared/UserSettings/TerminateChatSection";
import { TerminalPinSection } from "Components/UserSettings/TerminalPinSection";
import { useUserInfoQuery } from "Auth/Api/Queries/useUserInfoQuery";
import { useCurrentUserRole } from "Hooks/useCurrentUserAccessRole";
import { type AccessRoleCode, AccessRoleCodes } from "Models/AccessRoleCodes";

const ROLES_WITH_TERMINAL_PIN: ReadonlyArray<AccessRoleCode> = [
  AccessRoleCodes.Merchant,
  AccessRoleCodes.Employee,
];

export const UserSettingsSection = () => {
  const userRole = useCurrentUserRole();
  const isTerminalPinVisible =
    !!userRole && ROLES_WITH_TERMINAL_PIN.includes(userRole);
  const isQuickPaymentVisible = userRole !== AccessRoleCodes.Employee;
  // Only a persona with a handle has a Chat contract to terminate. Decided here, not inside the
  // section: the Stack puts a divider before every child, even one that renders nothing.
  const { data: userInfo } = useUserInfoQuery();
  const isTerminateChatVisible = !!userInfo?.handle;

  return (
    <Stack gap={3} divider={<Divider flexItem />}>
      {isTerminalPinVisible && <TerminalPinSection />}
      {isQuickPaymentVisible && <QuickPaymentToggle />}
      <BalanceVisibilityToggle />
      <PasswordSection />
      {isTerminateChatVisible && <TerminateChatSection />}
    </Stack>
  );
};
